import $ from 'jquery';
import { useEffect } from "react";

const ParticipantPopup2 = props => {

  useEffect(()=> {

    $('.Participant-btn2').click(function() {
      $('.Participant_pop2, .Participant_pop2 .popup_inwrap ').fadeIn();
    });

  }, []);

  return (
 
    <div className="popup Participant_pop2" >
        <div className="popup_wrap">

        {/* 상태 변경 */}
        <div className="popup_inwrap">
          <h5 className="section_tit">상태 변경 <span className="close_btn"></span></h5>
          <form action="">
            <div className="pop_content height_auto  ">
                <h4>my123, 49DsD님의 상태를 선택해주세요.
                </h4>
                <div class="selectBox large">
                  <span class="label">진행</span>
                  <ul class="optionList">
                    <li class="optionItem">대기</li>
                    <li class="optionItem">진행</li>
                    <li class="optionItem">중단</li>
                    <li class="optionItem">탈퇴</li>
                  </ul>
                </div>
                  
              </div>
              <div className="pop_foot">
                <div className="but_wrap">
                  <div>
                    <button type="button" className="secondary gray large pop_close">취소</button>
                  </div>
                  <div>
                    <button type="button" className=" primary large ">확인</button>
                  </div>
                </div>
              </div>
          </form>
        </div>
        </div>
      </div>

  );  
}
 export default ParticipantPopup2;